import React, {useEffect, useState} from 'react'
import {Global} from '@emotion/react'
import {useLocation} from 'react-router-dom'
import {useBreakpointValue} from '@salesforce/retail-react-app/app/components/shared/ui'

const ThirdPartyGlobalStyles = () => {
    const [isChatActive, setIsChatActive] = useState(false)
    const [isPDP, setIsPDP] = useState(false)
    const location = useLocation()
    const isDesktop = useBreakpointValue({base: false, lg: true})

    useEffect(() => {
        // Check if we're on a PDP (Product Detail Page)
        const isProductPage = location.pathname.match(/\/p\//)
        setIsPDP(!!isProductPage)
    }, [location.pathname])

    useEffect(() => {
        // Check if chat button or frame exists and is visible
        const checkChatStatus = () => {
            const chatFrame = document.querySelector('#embeddedMessagingFrame')
            const chatButton = document.querySelector('#embeddedMessagingConversationButton')

            const isFrameVisible =
                chatFrame && window.getComputedStyle(chatFrame).display !== 'none'
            const isButtonVisible =
                chatButton && window.getComputedStyle(chatButton).display !== 'none'

            // Chat is active if either the frame or button is visible
            setIsChatActive(isFrameVisible || isButtonVisible)
        }

        // Initial check
        checkChatStatus()

        // Observer to watch for chat button changes
        const observer = new MutationObserver(() => {
            checkChatStatus()
        })

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
        })

        return () => observer.disconnect()
    }, [])

    const thirdPartyStyles = {
        '.grecaptcha-badge': {
            visibility: 'hidden'
        },
        '.embeddedMessagingConversationButton': {
            bottom: isPDP ? '118px !important' : '24px !important',
            right: isDesktop ? '24px !important' : '16px !important'
        }
    }

    return <Global styles={thirdPartyStyles} />
}

export {ThirdPartyGlobalStyles}
